import Content from './content';
import Footer from './footer';
import Header from './header';
import Wrapper from './wrapper';
var JoveDialogLayout = {
  Wrapper: Wrapper,
  Header: Header,
  Footer: Footer,
  Content: Content
};
export default JoveDialogLayout;